// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ZXqsqvym1oYSZiOS2KhOc"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/container/PasswordForgottenPage/index.css
// module id = 316
// module chunks = 0